export enum CalendarEventDataTypesEnum {
    Exhibition = "exhibition",
    Press = "press",
    Career = "career",
}

export type CalendarEventDataType = "exhibition" | "press" | "career";

export interface CalendarEventRegionType {
    value: string;
    name: string;
}

export interface CalendarEventKeywordType {
    value: string;
    label: string;
}

export interface CalendarEventLinkType {
    label: string;
    href: string;
    target: string;
    iconType: string;
}

export interface CalendarEventOrganizationType {
    name: string;
    address: string;
}

export interface CalendarEventType {
    uid: number;
    startDate: string;
    endDate: string;
    title: string;
    dataType: CalendarEventDataType;
    eventType: string;
    keywords: CalendarEventKeywordType[];
    hall: number | string;
    booth: string | null;
    country: number | string;
    organization: CalendarEventOrganizationType | null;
    address: string | null;
    links: CalendarEventLinkType[];
}

export interface CalendarEventResponseData {
    events: Record<CalendarEventDataType, CalendarEventType[]>;
}

export interface CalendarSheet {
    year: number;
    month: number;
    monthName: string;
    days: string[];
    dayNames: string[];
}
